"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewPoints = function NewPoints() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.99997 13.5C5.20127 13.5 3.66827 12.8663 2.40095 11.599C1.13365 10.3317 0.5 8.79868 0.5\n6.99998C0.5 5.20128 1.13365 3.66827 2.40095 2.40095C3.66827 1.13365 5.20127 0.5 6.99997 0.5C8.79867\n0.5 10.3317 1.13365 11.599 2.40095C12.8663 3.66827 13.5 5.20128 13.5 6.99998C13.5 8.79868 12.8663\n10.3317 11.599 11.599C10.3317 12.8663 8.79867 13.5 6.99997 13.5ZM6.99997 12C8.38331 12 9.56247\n11.5125 10.5375 10.5375C11.5125 9.56248 12 8.38331 12 6.99998C12 5.61664 11.5125 4.43748 10.5375\n3.46248C9.56247 2.48748 8.38331 1.99998 6.99997 1.99998C5.61664 1.99998 4.43747 2.48748 3.46247\n3.46248C2.48747 4.43748 1.99997 5.61664 1.99997 6.99998C1.99997 8.38331 2.48747 9.56248 3.46247\n10.5375C4.43747 11.5125 5.61664 12 6.99997 12Z",
    fill: "#6E6D71"
  }));
};
var _default = NewPoints;
exports.default = _default;